module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n    <div class="m-modal-column"></div>\n\n\n     <div class="m-modal-section" >\n         <div class="m-modal-section__title">Select a preset</div>\n         <div class="m-modal-column">\n             <div class="form-group">\n                 <select class="form-control js-preset-select" name="type">\n                     <option value="">Choose...</option>\n                     ';
 _.each(getPresetList(), function(value){ 
__p+='\n                        <option value="'+
((__t=( value._id ))==null?'':__t)+
'" >'+
((__t=( value.name ))==null?'':__t)+
'</option>\n                     ';
 }); 
__p+='\n                 </select>\n             </div>\n         </div>\n    </div>\n\n\n\n    <div class="m-modal-section " >\n        <div class="m-modal-section__title">Real-time controls</div>\n        <div class="m-modal-column">\n            <div class="form-group">\n                <label for="name">Ring 1</label>\n                <select class="form-control js-color-ring-1" >\n                    <option value="">Please choose a color...</option>\n                    ';
 _.each(getRgbColors(), function(value) { 
__p+='\n                      <option value="'+
((__t=( value.hex ))==null?'':__t)+
'">'+
((__t=( value.label ))==null?'':__t)+
'</option>\n                    ';
 }); 
__p+='\n                </select>\n            </div>\n        </div>\n        <div class="m-modal-column">\n            <div class="form-group">\n                <label for="name">Ring 2</label>\n                <select class="form-control js-color-ring-2" >\n                  <option value="">Please choose a color...</option>\n                  ';
 _.each(getRgbColors(), function(value) { 
__p+='\n                    <option value="'+
((__t=( value.hex ))==null?'':__t)+
'">'+
((__t=( value.label ))==null?'':__t)+
'</option>\n                  ';
 }); 
__p+='\n                </select>\n            </div>\n        </div>\n    </div>\n\n\n\n    <div class="m-modal-section no-bottom-padding" >\n        <div class="m-modal-section__title">Daily routine composer</div>\n    </div>\n\n    <div class="routine__region"></div>\n\n\n    <div class="m-modal-section__full m-day-routine" >\n        <div class="m-routine-composer js-routine-composer"></div>\n    </div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./js/modules/devices/control/templates/control-rgb.html
// module id = 434
// module chunks = 0